import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { NotificationBuilder } from '../../shared/notificationBuilder'
import { AuthenticationService } from '../../authentication/authentication.service';
import { Router, ActivatedRoute } from '@angular/router'
import { StoreStatement, FinanceInfoDTO } from '../../models/profile.model';
import { NgxSmartModalService } from 'ngx-smart-modal';
import List from "typescript-dotnet-umd/System/Collections/List";

declare var $: any;

@Component({
  selector: 'app-admin-pipe',
  templateUrl: './admin-pipe.component.html',
  styleUrls: ['./admin-pipe.component.css']
})

export class AdminPipeComponent implements OnInit {
  loading = false
  constructor(private router: Router, private route: ActivatedRoute, private dashboardService: DashboardService, public ngxSmartModalService: NgxSmartModalService, private authenticationService: AuthenticationService, private notificationBuilder: NotificationBuilder) {
  }
  //accounts: AccountModel[] = null
  statements: StoreStatement[] = null
  finance: FinanceInfoDTO = null
  //invoiceEdit: StoreStatement = null
  totalRevenue: number = 0
  totalDonated: number = 0
  monthMetrics: List<number> = null

  ngOnInit() {
    $('body').addClass('sidebar-mini');
    this.dashboardService.getAdminFinanceInfo(true, null, null).subscribe(data => {
      debugger
      this.finance = data;
      //let test = this.statements.linq.groupBy(x => x.date).toDictionary(x)
      let obj = this
      this.finance.statements.forEach(function (invoice) {
        invoice.filterShow = true
        if (invoice.polenSubscription == 0 && invoice.totalCommission == 0) {
          obj.totalRevenue += (invoice.totalDonationApproved * invoice.commissionPercentage)
          if (invoice.commissionPercentage <= 0) {
            obj.totalDonated += invoice.totalDonationApproved
          }
          else {
            obj.totalDonated += (invoice.totalDonationApproved * (1 - invoice.commissionPercentage))
          }

        }
        else {
          obj.totalRevenue += invoice.polenSubscription + invoice.totalCommission
          obj.totalDonated += invoice.totalDonationApproved - invoice.totalCommission
        }

      });
    })
  }

  filterStatement(type) {

    this.finance.statements.forEach(function (invoice) {
      if (type == 'all') {
        invoice.filterShow = true
      }

      if (type == 'paid') {
        invoice.filterShow = (invoice.statusStatement >= 2 && invoice.statusStatement < 10)
      }
      if (type == 'waiting') {
        invoice.filterShow = invoice.statusStatement < 2
      }
      if (type == 'expired') {
        invoice.filterShow = invoice.statusStatement >= 10
      }
      if (type == 'donated') {
        invoice.filterShow = invoice.hasDonation
      }
    });

  }

}

